export default "/assets/images/housekeeping-service.mp4?2b106e234a71d7ffbf7dcf6f91396ee5";